module.exports = __webpack_public_path__ + "static/projektowanie-opakowan-kolor-cfff92013ee2406c4afddcedc4c468b6.jpg";